import { formatLatLon } from '@boatnav/core';
import { useGotoStore } from './gotoStore.js';
import { usePickPointStore } from './pickPointStore.js';
import { msg } from '../../lib/messages.js';
import './goto.css';

/**
 * Confirms a candidate point before it becomes the go-to pin (spec 13) — a
 * stray long-press or "Velg i kartet" tap must never silently move the pin.
 * Shared by both entry points (long-press and the map-tap fallback).
 */
export function PickPointSheet(): JSX.Element | null {
  const candidate = usePickPointStore((s) => s.candidate);
  const clearCandidate = usePickPointStore((s) => s.clearCandidate);
  const setGoto = useGotoStore((s) => s.set);

  if (!candidate) return null;

  const confirm = (): void => {
    setGoto({ point: candidate, name: formatLatLon(candidate.lat, candidate.lon) });
    clearCandidate();
  };

  return (
    <div className="sheet-backdrop" onClick={clearCandidate}>
      <div
        className="sheet"
        role="dialog"
        aria-modal="true"
        aria-label={msg.goto.confirmTitle}
        onClick={(e) => e.stopPropagation()}
      >
        <div className="sheet__handle" />
        <h2 className="sheet__title">{msg.goto.confirmTitle}</h2>
        <p className="sheet__body numeral">{formatLatLon(candidate.lat, candidate.lon)}</p>
        <div className="sheet__actions">
          <button type="button" className="btn btn--ghost" onClick={clearCandidate}>
            {msg.goto.cancel}
          </button>
          <button type="button" className="btn btn--accent" onClick={confirm}>
            {msg.goto.gotoHere}
          </button>
        </div>
      </div>
    </div>
  );
}
